
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";


const getName = (user) => {
    if (user.first_name && user.last_name)
        return user.first_name + ' ' + user.last_name;
    if (DataUtil.isPMDB()) {
        let newname = null;
        let email = user.email || user.originalObject.email;
        newname = DataUtil.convertEmail2Name(email);
        if (newname && newname !== "") return newname;
    }
    if (user && user.username) return user.username;

    return user;
}

export const getUserInfos = ({ storeObj, lg, property, configItem }) => {
    let obj = [];
    let labelField;
    if (configItem && configItem.params && configItem.params.userlist && configItem.params.userlist.labelField) {
        labelField = configItem.params.userlist.labelField
    }
    try {
        if (Array.isArray(storeObj) && storeObj.length > 0) {
            if (configItem && configItem.params && configItem.params.userlist
                && configItem.params.userlist.filter && configItem.params.userlist.filter.field) {
                const { field, values } = configItem.params.userlist.filter;
                storeObj.map(item => {
                    let newname = getName(item);;
                    if (labelField && item[labelField]) newname = item[labelField];
                    obj.push({ ID: item[property], DE: newname, EN: newname, [field]: item[field] });
                });
                if (field && values) {
                    let valuesArr = values.split(";");
                    if (valuesArr && valuesArr.length) {
                        obj = obj.filter(el => valuesArr.some(val => el[field] && val.toLowerCase() === el[field].toLowerCase()));
                    }
                }
            } else {
                storeObj.map(item => {
                    let newname = getName(item);
                    if (labelField && item[labelField]) newname = item[labelField];
                    obj.push({ ID: item[property], DE: newname, EN: newname });
                });
            }
            obj = DataUtil.uniqueArray(obj.sort(DataUtil.dynamicSortAndIgnoreCase(lg)));
        }
    } catch (e) {
        console.log("LAMTEST getUserInfos");
    }
    return obj;
};


export const getUserNameById = (userId, users) => {
    let user = userId;
    try {
        if (Array.isArray(users) && users.length > 0) {
            users.map(item => {
                if (item["id"] == userId) {
                    user = getName(item);
                }
            });
        }
    } catch (e) {
        console.log("LAMTEST getUserNameById");
    }

    return user;
}


export const getUserData = (user) => {
    if (user.granting && user.granting.options && user.granting.options.parent) {
        let { email, first_name, last_name } = user.granting.options.parent;

        if (!first_name || first_name === "") {
            first_name = DataUtil.subStringBefore(DataUtil.convertEmail2Name(email), " ");
            last_name = DataUtil.subStringAfter(DataUtil.convertEmail2Name(email), " ");
        }
        let name = first_name + " " + last_name;
        return { id: user.id, name, email }
    }

    return user;
}


export const getUserGroupsData = ({ elements, groupid }) => {
    let groups = [];

    if (DataUtil.isFrancetv()) {
        if (elements) {
            groups = elements.map(item => ({ ID: item.data.id, DE: item.data.name, EN: item.data.name, FR: item.data.name }))
            if (groupid || groupid == "0") {
                let group = parseInt(groupid);
                if (groups && groups[0] && groups[0].ID && parseInt(groups[0].ID) == group) {
                    return groups;
                }
                let userGroup = groups.find(item => parseInt(item.ID) == group);
                if (userGroup) {
                    groups = groups.filter(item => parseInt(item.ID) !== group);
                    return [userGroup, ...groups];
                }
            }
        }
    }
    return [];
}